import { sessionState } from 'src/app/core/services/signal-state.storage';
import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subject } from 'rxjs/internal/Subject';
import { AppService } from 'src/app/app.service';
import { GdoStepCompletionStatusComponent } from 'src/app/gdo/gdo-shared/gdo-shared-components/gdo-step-completion-status/gdo-step-completion-status.component';
import { transformIntoApiCallObj } from 'src/app/gdo/gdo-shared/Models/Constants';
import { ChangePlanInfo, Discount } from 'src/app/gdo/gdo-shared/Models/Interfaces';
import { packageCardDetails, StatusDTO } from 'src/app/gdo/gdo-shared/Models/Models';
import { GdoVehicleService } from '../../../gdo-vehicle.service';
import { PurchaseSubscriptionService } from 'src/app/shared/services/purchase-subscription.service';

@Component({
  selector: 'app-gdo-subscription-summary',
  templateUrl: './gdo-subscription-summary.component.html',
  styleUrls: ['./gdo-subscription-summary.component.scss'],
  standalone: false
})
export class GdoSubscriptionSummaryComponent implements OnInit {
  checked = false;
  @Input() type!: string;
  @Input() subsForm!: UntypedFormGroup;
  @Input() title!: string;
  @Input()
  parentSubject!: Subject<any>;
  discountEligibility: boolean = false
  packageDuration: string | null = null
  autoRenewCheck: boolean = false
  changePlanInfo: ChangePlanInfo | null = null;
  currentVIN: string | null = null;
  selectedCoupon: Discount | null = null
  nextBillingDate: string | null = null;
  couponList: Discount[] = [];
  isAcura: boolean = false;
  isBillToday: boolean = false;

  constructor(
    private dialog: MatDialog,
    private _myVehicleService: GdoVehicleService,
    private router: Router,
    private service: AppService,
     private purchasePlanHelperService: PurchaseSubscriptionService
  ) { }
  ngOnDestroy(): void {
    this.parentSubject?.unsubscribe();
  }

  ngOnInit(): void {
    this.setIsAcuraLocally();

    this.currentVIN = this.service.getVIN();
    this.parentSubject?.subscribe((event) => {
      this.getPurchasePlanInfo(true, false);
      // if (this.title == 'Purchase Subscription') {
      //   // Create PIN KI api call krni haiiii process same
      // } else {
      //   this.getPlanInfo(false, false);
      // }
      // this.getDiscountsInfo();
      this.setPackageInfo()
    });
  }
  setIsAcuraLocally() {
    let vehicleData = sessionState.getItem("vehicleMake");
    if (vehicleData) {
      vehicleData = vehicleData.toLowerCase();
      if (vehicleData == 'acura') {
        this.isAcura = true;
      }
    }
  }
  //// OLD ARSHAD's CODE is replaced by latest function below...
  // setPackageInfo() {
  //   let subsStartDate = this.subsForm.get("packageDetails").get("availablePackageSelection")?.value
  //     ?.subsStartDate
  //   let upcomingBillingDate = ((new Date(subsStartDate).getFullYear() + 1) +
  //     '-' +
  //     (new Date(subsStartDate).getMonth() < 10 ? "0" + new Date().getMonth() : new Date().getMonth()) +
  //     '-' +
  //     (new Date(subsStartDate).getDate() < 10 ? "0" + new Date().getDate() : new Date().getDate())
  //   )

  //   this.nextBillingDate = upcomingBillingDate
  // }

  //// this function is created because we are getting incorrect NEXT BILLING DATE...
  setPackageInfo() {
    const packageDetails = this.subsForm?.get('packageDetails')?.get('availablePackageSelection')?.value as any;
    if (!packageDetails) {
      this.packageDuration = null;
      this.nextBillingDate = null;
      return;
    }
    this.packageDuration = packageDetails.duration ?? null
    const subsStartDate = packageDetails.subsStartDate as string | null;
    if (!subsStartDate) {
      this.nextBillingDate = null;
      return;
    }
    if (this.title == 'Purchase Subscription') {
      this.nextBillingDate = subsStartDate
    } else {
      if (this.packageDuration == "5 Year Annual" || this.packageDuration == "3 Year Annual") {
        const startDate = new Date(subsStartDate);
        this.nextBillingDate = ((String(startDate.getMonth() + 1).padStart(2, '0')) +
          '/' +
          (String(startDate.getDate()).padStart(2, '0')) +
          '/' +
          (startDate.getFullYear() + 1)
        )
      } else {
        const endDate = new Date(subsStartDate)
        this.nextBillingDate = this.formatDate(new Date(endDate.setDate(endDate.getDate() + 30)))
      }
    }
    if (this.nextBillingDate && new Date(this.nextBillingDate).setHours(0, 0, 0, 0) == new Date().setHours(0, 0, 0, 0)) {
      this.isBillToday = true
    } else {
      this.isBillToday = false
    }

  }

  formatDate(date: Date | string): string {
    const parsedDate = new Date(date);
    return ((parsedDate.getMonth() + 1) +
      '/' +
      parsedDate.getDate() +
      '/' +
      parsedDate.getFullYear())
  }

  formatDate2(date: Date | string | null): string | null {
    if (date) {
      let dt = new Date(date);
      return (
        dt.getFullYear() +
        '-' +
        (dt.getMonth() < 10 ? "0" + (dt.getMonth() + 1) : (dt.getMonth() + 1)) +
        '-' +
        (dt.getDate() < 10 ? "0" + dt.getDate() : dt.getDate())
      );
    }
    else {
      return null;
    }

  }

  getDiscountsInfo() {
    let today = (new Date().getFullYear() +
      '-' +
      (new Date().getMonth() < 10 ? "0" + new Date().getMonth() : new Date().getMonth()) +
      '-' +
      (new Date().getDate() < 10 ? "0" + new Date().getDate() : new Date().getDate())
    )
    //as per the email, we are sending empty checkdate
    let data = {
      device: this.currentVIN,
      campaignName: "",
      checkDate: "",
      includeTranslations: false
    }
    this.service.Discounts(data).subscribe((res) => {
      if (res && res.status == "success") {
        this.couponList = []
        let resBody = res.responseBody
        if (resBody && resBody.couponDetails && resBody.couponDetails.length > 0) {
          for (const couponDetailsIterator of resBody.couponDetails) {
            if (couponDetailsIterator.eligibility == "E") {
              let compaignList = couponDetailsIterator.campaignInfoList
              for (const couponIterator of compaignList) {
                let couponInfo = couponIterator.couponInfo
                if (couponInfo && couponInfo.length > 0) {
                  for (const couponInfoIterator of couponInfo) {
                    let coupon: Discount = {
                      couponDesc: couponInfoIterator.couponDesc,
                      couponCode: couponInfoIterator.couponCode,
                      pid: couponInfoIterator.pid,
                      offerCode: couponInfoIterator.offerCode,
                      campaignCode: couponInfoIterator.campaignCode
                    }
                    let preSelectionSp = this.evaluatePreSelection()
                    if (preSelectionSp && coupon) {
                      if (coupon.campaignCode !== preSelectionSp.campaignCode && coupon.offerCode !== preSelectionSp.offerCode && coupon.pid !== preSelectionSp.pid) {
                        this.couponList.push(coupon)
                      }
                    }
                  }
                }
              }
              this.discountEligibility = true
            }
          }
        }
        if (this.couponList.length > 0) {
          this.discountEligibility = true
        } else {
          this.discountEligibility = false
        }
      }
    })
  }

  getPurchasePlanInfo(
    autoRenew: boolean,
    doWrite: boolean
  ): void {

    const packageDetails = this.subsForm
      ?.get('packageDetails')
      ?.get('availablePackageSelection')
      ?.value;

    const paymentDetails = this.subsForm
      ?.get('paymentDetails')
      ?.get('availablePaymentMethodSelection')
      ?.value;

    if (!packageDetails || !paymentDetails) {
      return;
    }

    this.packageDuration =
      packageDetails.duration ?? null;

    const selectedSP =
      this.service.getSelectedSp();

    const clientMasterPlanId =
      sessionState.getItem('clientMasterPlanId') ?? '';

    const clientRateScheduleId =
      this.service.evaluatePlan(
        clientMasterPlanId,
        packageDetails.duration ?? 'Monthly'
      ) ?? '';

    const contactDetails =
      this.subsForm?.get('contactDetails')?.value ?? {};

    const gdoVehicleDetails =
      this.service.getSelectedMp();

    let gdoSubscriptionType = '';
    let gdoPartnerName = '';
    let gdoChannel = '';

    const gdoVehicle = {
      device: '',
      make: '',
      clientAgreementID: '',
      model: '',
      trim: '',
      modelYear: ''
    };

    if (
      gdoVehicleDetails?.mpPlanInstFields?.length
    ) {

      gdoVehicleDetails.mpPlanInstFields
        .forEach((field: any) => {

          switch (
          field.planInstanceFieldName
          ) {

            case 'ModelYear':
              gdoVehicle.modelYear =
                field.planInstanceFieldValue;
              break;

            case 'VIN':
              gdoVehicle.device =
                field.planInstanceFieldValue;
              break;

            case 'Make':
              gdoVehicle.make =
                sessionState.getItem(
                  'vehicleMake'
                ) ||
                field.planInstanceFieldValue;
              break;

            case 'Model':
              gdoVehicle.model =
                field.planInstanceFieldValue;
              break;

            case 'Trim':
              gdoVehicle.trim =
                field.planInstanceFieldValue;
              break;

            case 'ClientAgreementID':
              gdoVehicle.clientAgreementID =
                field.planInstanceFieldValue;
              break;

            case 'subscriptionType':
              gdoSubscriptionType =
                field.planInstanceFieldValue;
              break;

            case 'partnerName':
              gdoPartnerName =
                field.planInstanceFieldValue;
              break;

            case 'Channel':
              gdoChannel =
                field.planInstanceFieldValue;
              break;
          }
        });
    }

    const contacts =
      this.purchasePlanHelperService
        .buildContacts(
          contactDetails,
          paymentDetails,
          contactDetails?.email,
          paymentDetails?.bill_email,
          false
        );

    const packageBodyData =
      this.purchasePlanHelperService
        .createPurchasePayload({

          eventType: 'paidEnrollment',

          autoRenew,

          doWrite,

          vehicle: gdoVehicle,

          subscriptionType:
            gdoSubscriptionType,

          partnerName:
            gdoPartnerName,

          channel:
            gdoChannel,

          contacts,

          couponCodes: [],

          clientPlanIdMPI:
            clientMasterPlanId,

          clientPlanIdSPI:
            selectedSP?.clientSuppPlanId,

          clientRateScheduleId:
            clientRateScheduleId,

          startDate:
            this.formatDate2(
              packageDetails?.subsStartDate
            ),

          endDate:
            this.formatDate2(
              this.nextBillingDate
            ),

          billingInfo: [
            {
              billFirstName:
                paymentDetails?.bill_first_name,

              billLastName:
                paymentDetails?.bill_last_name,

              billAddress1:
                paymentDetails?.bill_address1,

              billAddress2:
                paymentDetails?.bill_address2 || '',

              billCity:
                paymentDetails?.bill_city,

              billStateProv:
                paymentDetails?.bill_state_prov,

              billCountry:
                paymentDetails?.bill_country,

              billZipcode:
                paymentDetails?.bill_postal_cd,

              billEmail:
                paymentDetails?.bill_email,

              billAgreementId:
                paymentDetails?.bill_agreement_id,

              billContactIdx: 1,

              primaryPaymentMethodNo:
                this.service.getDefaultPaymentNo(),

              primaryPaymentMethodIdx:
                this.service.getDefaultPaymentNo()
            }
          ],

          paymentMethod: [
            {
              payMethodType:
                paymentDetails?.pay_method_type,

              paymentMethodIdx:
                this.service.getDefaultPaymentNo(),

              payMethodDescription:
                paymentDetails?.pay_method_description,

              billContactIdx: 1
            }
          ],

          reasonForExtension:
            'Want to use additional service'
        });

    this.service
      .PurchasePlan(packageBodyData)
      .subscribe({

        next: (res) => {

          if (res.status !== 'success') {

            this.dialog.open(
              GdoStepCompletionStatusComponent,
              {
                data: {
                  title: 'Error occured',
                  details: res.error_msg,
                  stepSuccessful: false
                },
                panelClass:
                  'custom-modalbox'
              }
            );

            return;
          }

          this.changePlanInfo =
            this.purchasePlanHelperService
              .buildChangePlanInfo(
                res?.responseBody?.accountInfo
              );

          const showResetPin =
            this.purchasePlanHelperService
              .shouldShowResetPin();

          if (!doWrite) {
            return;
          }

          if (showResetPin) {

            this.createPin();

            return;
          }

          const statusData: StatusDTO = {
            title:
              'Package Subscription Confirmed',
            details:
              'Customer’s subscription has been updated',
            stepSuccessful: true
          };

          const ref =
            this.dialog.open(
              GdoStepCompletionStatusComponent,
              {
                data: statusData,
                panelClass:
                  'custom-modalbox'
              }
            );

          ref.afterClosed()
            .subscribe(() => {

              sessionState.setItem(
                'planType',
                'notearlybird'
              );

              if (
                this.type === 'webview'
              ) {
                this.router.navigate(
                  ['/gdoWV'],
                  {
                    replaceUrl: true
                  }
                );
              } else {
                this.router.navigate(
                  ['/gdo-product'],
                  {
                    replaceUrl: true
                  }
                );
              }
            });
        },

        error: () => {

          const statusData: StatusDTO = {
            title: 'Failed',
            details:
              'There was an error. Check and update your address information. If this issue persists, the system may be down. Please try again later.',
            stepSuccessful: false
          };

          this.dialog.open(
            GdoStepCompletionStatusComponent,
            {
              data: statusData,
              panelClass:
                'custom-modalbox'
            }
          );
        }
      });
  }

  createPin() {
    const resetPinFormData = Object.assign(this.subsForm?.get('pinDetails')?.value ?? {});
    let vehicleData = this.service.getVehicleData()
    let ahmGlobalCode = ""
    if (vehicleData && vehicleData.ahmGlobalCode) {
      ahmGlobalCode = vehicleData.ahmGlobalCode
    }
    let data = {
      device: this.currentVIN,
      pin: resetPinFormData?.newPin,
      ahmGlobalCode: ahmGlobalCode
    }
    this.service.CreatePin(data).subscribe((res) => {
      let statusData: StatusDTO = {
        title: 'Package Subscription Confirmed',
        details: 'Customer’s subscription has been updated',
        stepSuccessful: true,
      };
      let ref = this.dialog.open(GdoStepCompletionStatusComponent, {
        data: statusData,
        panelClass: 'custom-modalbox'
      });

      ref.afterClosed().subscribe((result) => {
        sessionState.setItem("planType", "notearlybird")
        if (this.type == 'webview') {
          this.router.navigate(['/gdoWV'], { replaceUrl: true });
        } else {
          this.router.navigate(['/gdo-product'], { replaceUrl: true });
        }
      });
    })
  }

  getPlanInfo(doWrite: boolean, autoRenew: boolean) {
    const packageDetails = this.subsForm?.get('packageDetails')?.get('availablePackageSelection')?.value as any;
    if (!packageDetails) {
      return;
    }

    this.packageDuration = packageDetails.duration ?? null

    const selectedSP = this.service.getSelectedSp();
    const clientMasterPlanId = sessionState.getItem('clientMasterPlanId') ?? '';
    const clientRateScheduleId = this.service.evaluatePlan(clientMasterPlanId, packageDetails.duration ?? 'Monthly') ?? '';

    let pakagePlanData: any = {
      doWrite: doWrite,
      autoRenewal: autoRenew,
      clientPlanInstanceIdMPI: selectedSP.clientParentPlanInstanceId,
      clientPlanInstanceIdSPI: selectedSP.clientSuppPlanInstanceId,
      effectiveDate: packageDetails?.subsStartDate,
      newClientPlanId: selectedSP.clientSuppPlanId,
      newClientRateScheduleId: clientRateScheduleId,

      // couponCodes: this.selectedCoupon ? [{
      //   couponCode: this.selectedCoupon.couponCode,
      //   pid: this.selectedCoupon.pid,
      //   offerCode: this.selectedCoupon.offerCode,
      //   campaignCode: this.selectedCoupon.campaignCode
      // }] : [],
    };
    this.service.ConfirmChangePlan(pakagePlanData).subscribe((res) => {
      if (res.status == 'success') {
        this.changePlanInfo = res?.responseBody?.changePlanInfo;
        if (doWrite) {
          let statusData: StatusDTO = {
            title: 'Package Subscription Confirmed',
            details: 'Customer’s subscription has been updated',
            stepSuccessful: true,
          };
          let ref = this.dialog.open(GdoStepCompletionStatusComponent, {
            data: statusData, panelClass: 'custom-modalbox'
          });

          ref.afterClosed().subscribe((result) => {
            // sessionState.setItem("planType", "notearlybird")
            if (this.type == 'webview') {
              this.router.navigate(['/gdoWV'], { replaceUrl: true });
            } else {
              this.router.navigate(['/gdo-product'], { replaceUrl: true });
            }
          });
        }
      } else {
        let statusData: StatusDTO = {
          title: 'Failed',
          details: 'Something went wrong while getting subscription details, please try again.',
          stepSuccessful: false,
        };
        this.dialog.open(GdoStepCompletionStatusComponent, {
          data: statusData, panelClass: 'custom-modalbox'
        });
      }
    }, (err) => {
      let statusData: StatusDTO = {
        title: 'Failed',
        details: err.error.errorResponse,
        stepSuccessful: false,
      };
      this.dialog.open(GdoStepCompletionStatusComponent, {
        data: statusData, panelClass: 'custom-modalbox'
      });
    });
  }

  getHeaderTitleColorClass() {
    const subscription: packageCardDetails | null = this.subsForm?.get('packageDetails')?.get('availablePackageSelection')?.value ?? null;
    if (subscription?.isCurrent) {
      return 'font-12 grey-color font-weight-500';
    } else {
      return 'font-12 text-sub-color-3 font-weight-500';
    }
  }

  getColorClass() {
    const subscription: packageCardDetails | null = this.subsForm?.get('packageDetails')?.get('availablePackageSelection')?.value ?? null;

    if (subscription?.isCurrent) {
      return 'font-12 grey-color font-weight-400';
    } else {
      return 'font-12 text-sub-color-3 font-weight-400';
    }
  }
  tildeConversion(value: string) {
    if (value && value.length > 0) {
      return value;
    } else return '~';
  }
  onConfirmPurchase() {
    this.updateContactDetails();
  }
  updateContactDetails() {
    this.updateAcc();
  }
  checkAutoRenew(event: any) {
    this.autoRenewCheck = event.checked
  }
  updateAcc() {

    this.getPurchasePlanInfo(false, true);

  }
  onCouponSelected(event: any) {
    const selectedValue = event?.target?.value ?? '';
    if (selectedValue == 'select coupon') {
      this.selectedCoupon = null
      if (this.title == 'Purchase Subscription') {
        this.getPurchasePlanInfo(false, false);
      } else {
        this.getPlanInfo(false, false);
      }
      return
    }
    let selectedCoupon = this.couponList.find((item) => item.couponCode === selectedValue);
    let preSelectionSp = this.evaluatePreSelection()
    if (preSelectionSp && selectedCoupon) {
      if (selectedCoupon.campaignCode !== preSelectionSp.campaignCode && selectedCoupon.offerCode !== preSelectionSp.offerCode && selectedCoupon.pid !== preSelectionSp.pid) {
        this.selectedCoupon = selectedCoupon
        if (this.title == 'Purchase Subscription') {
          this.getPurchasePlanInfo(false, false);
        } else {
          this.getPlanInfo(false, false);
        }
      }
    }

  }
  onCancel() {
    sessionState.setItem("planType", "notearlybird")
    if (this.type) {
      this.router.navigate(['/gdoWV'], { replaceUrl: true });
    } else {
      this.router.navigate(['/gdo-product'], { replaceUrl: true });
    }
  }
  evaluatePreSelection() {
    let selectedSP = this.service.getSelectedSp()
    let preSelectedSp: any = {};
    if (selectedSP && selectedSP.spPlanInstFields && selectedSP.spPlanInstFields.length > 0) {
      for (const spField of selectedSP.spPlanInstFields) {
        if (spField.planInstanceFieldName === "OFFERCODE") {
          preSelectedSp.offerCode = spField.planInstanceFieldValue;
        }
        if (spField.planInstanceFieldName === "PID") {
          preSelectedSp.pid = spField.planInstanceFieldValue;
        }
        if (spField.planInstanceFieldName === "CAMPAIGNCODE") {
          preSelectedSp.campaignCode = spField.planInstanceFieldValue;
        }
      }
    }
    return preSelectedSp;
  }


  trackByNgForItem(index: number, item: any): string | number {
    return item?.value ?? item?.payment_method_no ?? item?.paymentMethodNo ?? item?.couponCode ?? item?.id ?? item?.title ?? item?.displayValue ?? item ?? index;
  }
}
function convertToNumericDigits(phone: string): any {
  if (phone && phone.length > 0) {
    phone = phone.replace(/[() -]/g, "");
    return phone;
  }
  else {
    return null;
  }
}